import { createAsyncThunk } from "@reduxjs/toolkit";
import * as jobService from "../../services/jobService";
import { enqueueSnackbar } from "notistack";
import * as API from "../../services/Api";

export const getJobs = createAsyncThunk(
  "job/getJobs",
  async (params, { getState, rejectWithValue }) => {
    try {
      let status, page, limit;

      if (typeof params === "object" && params !== null) {
        status = params.status;
        page = params.page;
        limit = params.limit;
      } else {
        status = params;
      }

      const state = getState();
      const token =
        state.auth?.user?.authentication?.accessToken ||
        localStorage.getItem("token");

      if (token) {
        API.setHeaderAuthorization(token);
      }

      const response = await jobService.getJobs(status, page, limit);
      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const getJobById = createAsyncThunk(
  "job/getJobById",
  async (id, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token =
        state.auth?.user?.authentication?.accessToken ||
        localStorage.getItem("token");

      if (token) {
        API.setHeaderAuthorization(token);
      }

      const response = await jobService.getJobById(id);
      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const createJob = createAsyncThunk(
  "job/createJob",
  async (jobData, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token =
        state.auth?.user?.authentication?.accessToken ||
        localStorage.getItem("token");

      if (token) {
        API.setHeaderAuthorization(token);
      }

      const response = await jobService.createJob(jobData);
      enqueueSnackbar(response.message || "Job created successfully", {
        variant: "success",
      });

      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const updateJob = createAsyncThunk(
  "job/updateJob",
  async ({ id, data }, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token =
        state.auth?.user?.authentication?.accessToken ||
        localStorage.getItem("token");

      if (token) {
        API.setHeaderAuthorization(token);
      }

      const response = await jobService.updateJob(id, data);
      enqueueSnackbar(response.message || "Job updated successfully", {
        variant: "success",
      });

      return { ...response, id };
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const jobAction = createAsyncThunk(
  "job/jobAction",
  async ({ id, data }, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token =
        state.auth?.user?.authentication?.accessToken ||
        localStorage.getItem("token");

      if (token) {
        API.setHeaderAuthorization(token);
      }

      const response = await jobService.jobAction(id, data);

      enqueueSnackbar(response.message, {
        variant: "success",
      });

      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const actionUploadedWork = createAsyncThunk(
  "job/actionUploadedWork",
  async ({ uwId, data }, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token =
        state.auth?.user?.authentication?.accessToken ||
        localStorage.getItem("token");

      if (token) {
        API.setHeaderAuthorization(token);
      }

      const response = await jobService.actionUploadedWork(uwId, data);

      enqueueSnackbar(response.message || "Action completed successfully", {
        variant: "success",
      });

      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const createTicket = createAsyncThunk(
  "job/createTicket",
  async (ticketData, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token =
        state.auth?.user?.authentication?.accessToken ||
        localStorage.getItem("token");

      if (token) {
        API.setHeaderAuthorization(token);
      }

      const response = await jobService.createTicket(ticketData);
      enqueueSnackbar(response.message || "Ticket created successfully", {
        variant: "success",
      });

      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const deleteJob = createAsyncThunk(
  "job/deleteJob",
  async (id, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token =
        state.auth?.user?.authentication?.accessToken ||
        localStorage.getItem("token");

      if (token) {
        API.setHeaderAuthorization(token);
      }

      const response = await jobService.deleteJob(id);
      enqueueSnackbar(response.message || "Job deleted successfully", {
        variant: "success",
      });

      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const completeJob = createAsyncThunk(
  "job/completeJob",
  async (id, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token =
        state.auth?.user?.authentication?.accessToken ||
        localStorage.getItem("token");

      if (token) {
        API.setHeaderAuthorization(token);
      }

      const response = await jobService.completeJob(id);
      enqueueSnackbar(response.message || "Job completed successfully", {
        variant: "success",
      });

      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);
